import GuestI from '../interfaces/Guest';

const getMaxPageNumber = (guests: GuestI[]) => {
    return Math.ceil(guests.length / 10);
};

export default getMaxPageNumber;
